import { Button, Flex, Input, Text, useToast } from '@chakra-ui/react'
import { Card } from '../Card'
import { useMutation } from 'react-query'
import { editInfoDataSaida, editInfoDestacaFrete, editInfoTransportadora } from '../requests'
import { useForm } from 'react-hook-form'

export function ShippingCompanyStep({ partner, payment, refetch }) {
  const { register, handleSubmit } = useForm()

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async ({ codTransp, NUNOTA, newDate }) => {
      await Promise.all([editInfoTransportadora(codTransp, NUNOTA), editInfoDataSaida(newDate, NUNOTA)])
    },
    mutationKey: 'edit-info-transportadora',
    onSuccess: () => {
      refetch()
      toast({
        title: 'Dados da transportadora atualizados com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao atualizar dados da transportadora',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  const { mutateAsync: destacaFreteAsync, isLoading: isLoadingDestacaFrete } = useMutation({
    mutationFn: async ({ vlr_frete, numero_nota }) => {
      await editInfoDestacaFrete(vlr_frete, numero_nota)
    },
    onSuccess: () => {
      refetch()
      toast({
        title: 'Frete atualizado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao atualizar frete',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function handleEditInfoTransportadora(data) {
    await mutateAsync({
      codTransp: data.codTransp,
      NUNOTA: payment.NUNOTA,
      newDate: data.newDate,
    })
  }

  async function handleEditDestacaFrete(data) {
    await destacaFreteAsync({
      vlr_frete: data.destacaFrete,
      numero_nota: payment.NUNOTA,
    })
  }

  return (
    <Flex flexDir="column" height="100%">
      <Card title="DADOS DA TRANSPORTADORA" entreguePor={partner?.transp_nome} saidaMercadoria={partner?.transp_saida} isGreen />

      <Flex
        as="form"
        mb="1rem"
        paddingInline="1rem"
        marginTop="auto"
        justifyContent="space-between"
        gap={2}
        onSubmit={handleSubmit(handleEditDestacaFrete)}
        alignItems="flex-end"
      >
        <Flex flexDir="column" flex={1}>
          <Text as="label" htmlFor="destacaFrete">
            Destaca Frete
          </Text>
          <Input id="destacaFrete" placeholder="Destaca Frete" {...register('destacaFrete')} w="100%" />
        </Flex>
        <Button maxW="120px" type="submit" w="100%" isLoading={isLoadingDestacaFrete} isDisabled={isLoadingDestacaFrete}>
          Atualizar
        </Button>
      </Flex>
      <Flex
        as="form"
        mb="1rem"
        paddingInline="1rem"
        marginTop="auto"
        justifyContent="space-between"
        flexDir={'column'}
        gap={2}
        onSubmit={handleSubmit(handleEditInfoTransportadora)}
      >
        <Input type={'date'} w="100%" {...register('newDate')} />
        <Input placeholder="Código transportadora" {...register('codTransp')} w="100%" />
        <Button type="submit" w="100%" isLoading={isLoading} isDisabled={isLoading}>
          Atualizar
        </Button>
      </Flex>
    </Flex>
  )
}
